// extracted by mini-css-extract-plugin
export default {"title":"Category_title__W9k1h","item":"Category_item__pIFhE","subTitle":"Category_subTitle__lLa4F"};